// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"64PZj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDark", ()=>isDark);
parcelHelpers.export(exports, "mapStyle", ()=>mapStyle);
parcelHelpers.export(exports, "C", ()=>C);
parcelHelpers.export(exports, "routeLineGradient", ()=>routeLineGradient);
parcelHelpers.export(exports, "stationIconColor", ()=>stationIconColor);
parcelHelpers.export(exports, "stationTextColor", ()=>stationTextColor);
const isDark = document.documentElement.classList.contains('dark');
const mapStyle = isDark ? '/data/style-dark.json' : '/data/style.json';
// Semantic color palette for map layers — light/dark pairs
const light = {
    stopRed: '#f01b48',
    stopCircleBg: '#fff',
    routeLine: '#1a1a1a',
    routeLineMid: '#666666',
    routeCasing: '#fff',
    text: '#000',
    textHalo: '#fff',
    metroPurple: '#5301a4',
    serviceGreen: '#1e5a0e',
    serviceGreenHalo: '#eeffd1',
    linkBlue: '#007aff',
    routeLineOpacity: 0.5,
    stationHaloWidth: 0.8
};
const dark = {
    stopRed: '#ff4d6d',
    stopCircleBg: '#1a1a1a',
    routeLine: '#c0c0c0',
    routeLineMid: '#e0e0e0',
    routeCasing: '#0a0a0a',
    text: '#e0e0e0',
    textHalo: '#000',
    metroPurple: '#a855f7',
    serviceGreen: '#66e848',
    serviceGreenHalo: '#0a1a05',
    linkBlue: '#4da3ff',
    routeLineOpacity: 0.8,
    stationHaloWidth: 1.5
};
const C = isDark ? dark : light;
const routeLineGradient = [
    'interpolate',
    [
        'linear'
    ],
    [
        'line-progress'
    ],
    0,
    C.routeLine,
    0.5,
    C.routeLineMid,
    1,
    C.routeLine
];
// station-color field accessor
const STATION_COLOR = [
    'get',
    'station-color'
];
// Dark-mode brightening map: raw line colors → legible versions on dark backgrounds
const DARK_COLOR_MAP = {
    // Yellows
    '#FFD700': '#FFEA00',
    '#ffdf00': '#FFEA00',
    '#ffff00': '#FFEA00',
    yellow: '#FFEA00',
    // Purples / violets
    purple: '#c084fc',
    violet: '#f0abfc',
    '#800080': '#c084fc',
    '#5301a4': '#a855f7',
    '#553592': '#a855f7',
    '#4B0082': '#818cf8',
    '#7b2fbe': '#c084fc',
    '#77248b': '#c084fc',
    '#9b59b6': '#c084fc',
    '#e542de': '#f0abfc',
    '#ee82ee': '#f0abfc',
    '#cc338b': '#f472b6',
    // Blues
    blue: '#60a5fa',
    '#000080': '#60a5fa',
    '#00008b': '#60a5fa',
    '#0000ff': '#60a5fa',
    '#4169e1': '#60a5fa',
    '#3281c4': '#60a5fa',
    // Greens
    green: '#4ade80',
    '#008000': '#4ade80',
    '#009933': '#4ade80',
    '#53b848': '#4ade80',
    '#00a650': '#4ade80',
    '#009b3a': '#4ade80',
    '#00843d': '#4ade80',
    // Teals
    '#0097A7': '#4dd0e1',
    '#00897B': '#34d399',
    // Reds / oranges
    maroon: '#f87171',
    '#8b0000': '#f87171',
    '#ff0000': '#f87171',
    '#ff4040': '#f87171',
    '#ff8c00': '#fb923c',
    '#ff9900': '#fb923c',
    // Browns (commuter rail)
    '#795548': '#bcaaa4',
    '#5D4037': '#a1887f'
};
const stationIconColor = isDark ? [
    'case',
    ...Object.entries(DARK_COLOR_MAP).flatMap(([src, dest])=>[
            [
                '==',
                STATION_COLOR,
                src
            ],
            dest
        ]),
    [
        'to-color',
        STATION_COLOR
    ]
] : [
    'to-color',
    STATION_COLOR
];
const stationTextColor = stationIconColor;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"d3SoU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeName", ()=>normalizeName);
parcelHelpers.export(exports, "compareNormalizedNames", ()=>compareNormalizedNames);
var _cityConfig = require("../city-config");
/**
 * Default characters to remove when normalizing names
 */ const DEFAULT_NORMALIZE_CHARS = [
    '-',
    ' '
];
const normalizeName = (name, cityCode)=>{
    if (!name) return '';
    const config = (0, _cityConfig.getConfigForCity)(cityCode);
    const normalizeConfig = config === null || config === void 0 ? void 0 : config.normalizeNames;
    // If normalization is not enabled for this city, return lowercase name as-is
    if (!(normalizeConfig === null || normalizeConfig === void 0 ? void 0 : normalizeConfig.enabled)) return name.toLowerCase();
    const charsToRemove = normalizeConfig.removeChars || DEFAULT_NORMALIZE_CHARS;
    let normalized = name.toLowerCase();
    for (const char of charsToRemove)normalized = normalized.split(char).join('');
    return normalized;
};
const compareNormalizedNames = (name1, name2, cityCode)=>{
    return normalizeName(name1, cityCode) === normalizeName(name2, cityCode);
};

},{"../city-config":"7oMBO","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"6yMmk":[function(require,module,exports,__globalThis) {
/**
 * Shared geometry utilities for polyline operations
 * Used by both app.js and arrival.js
 */ /**
 * Calculate Euclidean distance between two points
 * Uses optimized math operations
 * @param {Array} p1 - First point [lng, lat]
 * @param {Array} p2 - Second point [lng, lat]
 * @returns {number} Distance
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pointDistance", ()=>pointDistance);
parcelHelpers.export(exports, "pointDistanceSquared", ()=>pointDistanceSquared);
parcelHelpers.export(exports, "closestPointOnSegment", ()=>closestPointOnSegment);
parcelHelpers.export(exports, "findClosestPointOnPolyline", ()=>findClosestPointOnPolyline);
parcelHelpers.export(exports, "cropPolylineFromPoint", ()=>cropPolylineFromPoint);
parcelHelpers.export(exports, "cropPolylineBetweenPoints", ()=>cropPolylineBetweenPoints);
parcelHelpers.export(exports, "findBestRouteSegment", ()=>findBestRouteSegment);
parcelHelpers.export(exports, "decodePolylineCached", ()=>decodePolylineCached);
parcelHelpers.export(exports, "clearPolylineCache", ()=>clearPolylineCache);
const pointDistance = (p1, p2)=>{
    const dx = p2[0] - p1[0];
    const dy = p2[1] - p1[1];
    return Math.sqrt(dx * dx + dy * dy);
};
const pointDistanceSquared = (p1, p2)=>{
    const dx = p2[0] - p1[0];
    const dy = p2[1] - p1[1];
    return dx * dx + dy * dy;
};
const closestPointOnSegment = (point, segmentStart, segmentEnd)=>{
    const [px, py] = point;
    const [x1, y1] = segmentStart;
    const [x2, y2] = segmentEnd;
    const dx = x2 - x1;
    const dy = y2 - y1;
    const lengthSquared = dx * dx + dy * dy;
    if (lengthSquared === 0) return segmentStart;
    const t = Math.max(0, Math.min(1, ((px - x1) * dx + (py - y1) * dy) / lengthSquared));
    return [
        x1 + t * dx,
        y1 + t * dy
    ];
};
const findClosestPointOnPolyline = (point, coordinates)=>{
    let minDistance = Infinity;
    let closestPoint = null;
    let closestSegmentIndex = -1;
    for(let i = 0, len = coordinates.length - 1; i < len; i++){
        const closestOnSegment = closestPointOnSegment(point, coordinates[i], coordinates[i + 1]);
        const distance = pointDistance(point, closestOnSegment);
        if (distance < minDistance) {
            minDistance = distance;
            closestPoint = closestOnSegment;
            closestSegmentIndex = i;
        }
    }
    return {
        point: closestPoint,
        segmentIndex: closestSegmentIndex,
        distance: minDistance
    };
};
const cropPolylineFromPoint = (coordinates, closestPoint, segmentIndex)=>{
    if (segmentIndex < 0 || segmentIndex >= coordinates.length - 1) return coordinates;
    const cropped = [
        closestPoint,
        ...coordinates.slice(segmentIndex + 1)
    ];
    return cropped.length > 1 ? cropped : coordinates;
};
/**
 * Build a cropped polyline between two already-located closest-point results.
 * Shared by cropPolylineBetweenPoints (which locates the points itself) and
 * findBestRouteSegment (which has already located them while scoring variants).
 * @param {Array} coordinates - Original polyline coordinates
 * @param {Object} startClosest - Result of findClosestPointOnPolyline for the start point
 * @param {Object} endClosest - Result of findClosestPointOnPolyline for the end point
 * @returns {Array} Cropped coordinates between the two points
 */ const buildCroppedSegment = (coordinates, startClosest, endClosest)=>{
    if (!startClosest.point || !endClosest.point) return coordinates;
    // Determine which point comes first along the polyline
    let actualStart = startClosest;
    let actualEnd = endClosest;
    const startSegIdx = startClosest.segmentIndex;
    const endSegIdx = endClosest.segmentIndex;
    // If start segment comes after end segment, swap them
    if (startSegIdx > endSegIdx) {
        actualStart = endClosest;
        actualEnd = startClosest;
    } else if (startSegIdx === endSegIdx) {
        // Both on same segment - determine order by position along segment
        const segStart = coordinates[startSegIdx];
        const segEnd = coordinates[startSegIdx + 1];
        // Calculate parameter t for each closest point along the segment
        // t represents position along segment (0 = start, 1 = end)
        const calculateT = (point, segStart, segEnd)=>{
            const [px, py] = point;
            const [x1, y1] = segStart;
            const [x2, y2] = segEnd;
            const dx = x2 - x1;
            const dy = y2 - y1;
            const lengthSquared = dx * dx + dy * dy;
            if (lengthSquared === 0) return 0;
            const t = Math.max(0, Math.min(1, ((px - x1) * dx + (py - y1) * dy) / lengthSquared));
            return t;
        };
        const startT = calculateT(actualStart.point, segStart, segEnd);
        const endT = calculateT(actualEnd.point, segStart, segEnd);
        // If start comes after end on the segment, swap them
        if (startT > endT) {
            actualStart = endClosest;
            actualEnd = startClosest;
        }
    }
    // Build the cropped polyline
    const cropped = [
        actualStart.point
    ];
    // Add intermediate coordinates between the segments
    const startIdx = actualStart.segmentIndex;
    const endIdx = actualEnd.segmentIndex;
    // Ensure we have valid indices
    if (startIdx >= 0 && endIdx >= 0 && startIdx < coordinates.length - 1 && endIdx < coordinates.length - 1) {
        if (startIdx < endIdx) {
            // Add coordinates from after start segment to before end segment
            // This includes all intermediate points to preserve the polyline shape
            for(let i = startIdx + 1; i <= endIdx; i++)if (coordinates[i] && Array.isArray(coordinates[i]) && coordinates[i].length >= 2) cropped.push(coordinates[i]);
        } else if (startIdx > endIdx) {
            // Points are in reverse order - this shouldn't happen after swapping, but handle it
            // Return the polyline in reverse order
            for(let i = startIdx; i >= endIdx; i--)if (coordinates[i] && Array.isArray(coordinates[i]) && coordinates[i].length >= 2) cropped.push(coordinates[i]);
        } else // Both points are on the same segment
        // When both points are on the same segment, we should still preserve the polyline structure
        // by including the segment endpoints. This ensures we follow the actual route path.
        // Include the segment end point to preserve polyline structure
        if (startIdx + 1 < coordinates.length) {
            const segmentEnd = coordinates[startIdx + 1];
            if (segmentEnd && Array.isArray(segmentEnd) && segmentEnd.length >= 2) {
                // Only add if it's different from the end point to avoid duplicates
                const endPointArr = actualEnd.point;
                if (!endPointArr || Math.abs(segmentEnd[0] - endPointArr[0]) > 1e-9 || Math.abs(segmentEnd[1] - endPointArr[1]) > 1e-9) cropped.push(segmentEnd);
            }
        }
    }
    // Add the end point (avoid duplicate if it's already the last point)
    if (actualEnd.point && Array.isArray(actualEnd.point) && actualEnd.point.length >= 2) {
        const lastPoint = cropped[cropped.length - 1];
        if (!lastPoint || Math.abs(lastPoint[0] - actualEnd.point[0]) > 1e-9 || Math.abs(lastPoint[1] - actualEnd.point[1]) > 1e-9) cropped.push(actualEnd.point);
    }
    // Validate the result before returning
    if (cropped.length >= 2 && cropped.every((coord)=>Array.isArray(coord) && coord.length >= 2)) return cropped;
    // Fallback to original coordinates if cropping failed
    return coordinates;
};
const cropPolylineBetweenPoints = (coordinates, startPoint, endPoint)=>{
    if (!coordinates || coordinates.length < 2) return coordinates;
    const startClosest = findClosestPointOnPolyline(startPoint, coordinates);
    const endClosest = findClosestPointOnPolyline(endPoint, coordinates);
    return buildCroppedSegment(coordinates, startClosest, endClosest);
};
const findBestRouteSegment = (servicePolylines, fromCoords, toCoords, decoder)=>{
    if (!(servicePolylines === null || servicePolylines === void 0 ? void 0 : servicePolylines.length)) return null;
    let bestCropped = null;
    let bestDistance = Infinity;
    for (const encoded of servicePolylines){
        var _polyline_coordinates;
        const polyline = decodePolylineCached(encoded, decoder);
        if (!(polyline === null || polyline === void 0 ? void 0 : (_polyline_coordinates = polyline.coordinates) === null || _polyline_coordinates === void 0 ? void 0 : _polyline_coordinates.length)) continue;
        const startClosest = findClosestPointOnPolyline(fromCoords, polyline.coordinates);
        const endClosest = findClosestPointOnPolyline(toCoords, polyline.coordinates);
        if (!startClosest.point || !endClosest.point) continue;
        const totalDist = startClosest.distance + endClosest.distance;
        if (totalDist < bestDistance) {
            const cropped = buildCroppedSegment(polyline.coordinates, startClosest, endClosest);
            if (Array.isArray(cropped) && cropped.length >= 2 && cropped.every((c)=>Array.isArray(c) && c.length >= 2)) {
                bestDistance = totalDist;
                bestCropped = cropped;
            }
        }
    }
    return bestCropped;
};
// Cache for decoded polylines to avoid redundant decoding
const polylineCache = new Map();
const MAX_CACHE_SIZE = 500;
const decodePolylineCached = (encoded, decoder)=>{
    if (polylineCache.has(encoded)) return polylineCache.get(encoded);
    const decoded = decoder(encoded);
    // Limit cache size with simple LRU-like behavior
    if (polylineCache.size >= MAX_CACHE_SIZE) {
        const firstKey = polylineCache.keys().next().value;
        polylineCache.delete(firstKey);
    }
    polylineCache.set(encoded, decoded);
    return decoded;
};
const clearPolylineCache = ()=>{
    polylineCache.clear();
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"3x2L0":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Based off of [the offical Google document](https://developers.google.com/maps/documentation/utilities/polylinealgorithm)
 *
 * Some parts from [this implementation](http://facstaff.unca.edu/mcmcclur/GoogleMaps/EncodePolyline/PolylineEncoder.js)
 * by [Mark McClure](http://facstaff.unca.edu/mcmcclur/)
 *
 * @module polyline
 */ var polyline = {};
function py2_round(value) {
    // Google's polyline algorithm uses the same rounding strategy as Python 2, which is different from JS for negative values
    return Math.floor(Math.abs(value) + 0.5) * (value >= 0 ? 1 : -1);
}
function encode(current, previous, factor) {
    current = py2_round(current * factor);
    previous = py2_round(previous * factor);
    var coordinate = (current - previous) * 2;
    if (coordinate < 0) coordinate = -coordinate - 1;
    var output = '';
    while(coordinate >= 0x20){
        output += String.fromCharCode((0x20 | coordinate & 0x1f) + 63);
        coordinate /= 32;
    }
    output += String.fromCharCode((coordinate | 0) + 63);
    return output;
}
/**
 * Decodes to a [latitude, longitude] coordinates array.
 *
 * This is adapted from the implementation in Project-OSRM.
 *
 * @param {String} str
 * @param {Number} precision
 * @returns {Array}
 *
 * @see https://github.com/Project-OSRM/osrm-frontend/blob/master/WebContent/routing/OSRM.RoutingGeometry.js
 */ polyline.decode = function(str, precision) {
    var index = 0, lat = 0, lng = 0, coordinates = [], shift = 0, result = 0, byte = null, latitude_change, longitude_change, factor = Math.pow(10, Number.isInteger(precision) ? precision : 5);
    // Coordinates have variable length when encoded, so just keep
    // track of whether we've hit the end of the string. In each
    // loop iteration, a single coordinate is decoded.
    while(index < str.length){
        // Reset shift, result, and byte
        byte = null;
        shift = 1;
        result = 0;
        do {
            byte = str.charCodeAt(index++) - 63;
            result += (byte & 0x1f) * shift;
            shift *= 32;
        }while (byte >= 0x20);
        latitude_change = result & 1 ? (-result - 1) / 2 : result / 2;
        shift = 1;
        result = 0;
        do {
            byte = str.charCodeAt(index++) - 63;
            result += (byte & 0x1f) * shift;
            shift *= 32;
        }while (byte >= 0x20);
        longitude_change = result & 1 ? (-result - 1) / 2 : result / 2;
        lat += latitude_change;
        lng += longitude_change;
        coordinates.push([
            lat / factor,
            lng / factor
        ]);
    }
    return coordinates;
};
/**
 * Encodes the given [latitude, longitude] coordinates array.
 *
 * @param {Array.<Array.<Number>>} coordinates
 * @param {Number} precision
 * @returns {String}
 */ polyline.encode = function(coordinates, precision) {
    if (!coordinates.length) return '';
    var factor = Math.pow(10, Number.isInteger(precision) ? precision : 5), output = encode(coordinates[0][0], 0, factor) + encode(coordinates[0][1], 0, factor);
    for(var i = 1; i < coordinates.length; i++){
        var a = coordinates[i], b = coordinates[i - 1];
        output += encode(a[0], b[0], factor);
        output += encode(a[1], b[1], factor);
    }
    return output;
};
function flipped(coords) {
    var flipped = [];
    for(var i = 0; i < coords.length; i++){
        var coord = coords[i].slice();
        flipped.push([
            coord[1],
            coord[0]
        ]);
    }
    return flipped;
}
/**
 * Encodes a GeoJSON LineString feature/geometry.
 *
 * @param {Object} geojson
 * @param {Number} precision
 * @returns {String}
 */ polyline.fromGeoJSON = function(geojson, precision) {
    if (geojson && geojson.type === 'Feature') geojson = geojson.geometry;
    if (!geojson || geojson.type !== 'LineString') throw new Error('Input must be a GeoJSON LineString');
    return polyline.encode(flipped(geojson.coordinates), precision);
};
/**
 * Decodes to a GeoJSON LineString geometry.
 *
 * @param {String} str
 * @param {Number} precision
 * @returns {Object}
 */ polyline.toGeoJSON = function(str, precision) {
    var coords = polyline.decode(str, precision);
    return {
        type: 'LineString',
        coordinates: flipped(coords)
    };
};
if (module.exports) module.exports = polyline;

},{}],"lXpo4":[function(require,module,exports,__globalThis) {
// MapLibre GL JS varint limit is approximately 2^63, but JavaScript safe integer
// limit is 2^53. We use a conservative limit to avoid varint encoding issues.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "decode", ()=>decode);
const VARINT_SAFE_LIMIT = 9007199254740991; // Number.MAX_SAFE_INTEGER
// Store reverse mapping for IDs that exceed varint limits
// This is a simple in-memory cache that persists during the session
const idReverseMap = new Map();
// Fast FNV-1a hash function (32-bit) - optimized for performance
const fnv1a32 = (str)=>{
    let hash = 2166136261; // FNV offset basis
    const fnvPrime = 16777619; // FNV prime for 32-bit
    for(let i = 0; i < str.length; i++){
        hash ^= str.charCodeAt(i);
        // Standard FNV-1a multiplication (JS engines optimize this well)
        hash = hash * fnvPrime >>> 0; // Force to 32-bit unsigned
    }
    return hash;
};
// Estimate if old encoding will exceed varint limit based on string length
// Each alphanumeric char produces 2-3 digit char code (48-122)
// Worst case: 3 digits per char, so 3n digits = 10^(3n) as a number
// We want 10^(3n) < VARINT_SAFE_LIMIT, so 3n < log10(VARINT_SAFE_LIMIT) ≈ 15.95
// Therefore n < 5.3, so we use n <= 5 as safe threshold
// For n > 5, we check more carefully, but n > 10 will almost certainly fail
const willOldEncodingExceedLimit = (str)=>{
    // Quick check: if string is very short, old encoding will definitely work
    if (str.length <= 5) return false;
    // If string is very long, old encoding will definitely fail
    if (str.length > 10) return true;
    // For medium lengths, estimate: assume average 2.5 digits per char
    // 2.5 * length digits = 10^(2.5*length) as number
    // Check if 10^(2.5*length) > VARINT_SAFE_LIMIT
    const estimatedDigits = Math.ceil(str.length * 2.5);
    return estimatedDigits > 15; // log10(VARINT_SAFE_LIMIT) ≈ 15.95
};
// Optimized old encoding - direct string building instead of regex
const oldEncode = (str)=>{
    let result = '';
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (code >= 48 && code <= 57 || code >= 65 && code <= 90 || code >= 97 && code <= 122) result += code;
    }
    return result ? parseInt(result, 10) : NaN;
};
// Fast old decode - optimized path without regex where possible
const oldDecode = (numStr)=>{
    // Old encoding uses pairs of digits (char codes)
    // Try to decode by splitting into 2-3 digit groups
    const charCodes = [];
    let i = 0;
    while(i < numStr.length){
        // Try 2-digit code first (most common: 48-122)
        if (i + 2 <= numStr.length) {
            const code2 = parseInt(numStr.substr(i, 2), 10);
            if (code2 >= 32 && code2 <= 126) {
                charCodes.push(code2);
                i += 2;
                continue;
            }
        }
        // Try 3-digit code (for codes 100-126)
        if (i + 3 <= numStr.length) {
            const code3 = parseInt(numStr.substr(i, 3), 10);
            if (code3 >= 100 && code3 <= 126) {
                charCodes.push(code3);
                i += 3;
                continue;
            }
        }
        // If neither works, skip one digit and try again
        i++;
    }
    return charCodes.length > 0 ? String.fromCharCode(...charCodes) : null;
};
const encode = (id)=>{
    const str = String(id);
    // Fast path: for short identifiers, old encoding will work and is more efficient
    // Skip hash-based encoding entirely for short strings
    if (!willOldEncodingExceedLimit(str)) {
        const oldEncoded = oldEncode(str);
        // For short strings, old encoding should always work
        if (!isNaN(oldEncoded) && oldEncoded > 0 && oldEncoded <= VARINT_SAFE_LIMIT) return oldEncoded;
    }
    // For longer identifiers, check if old encoding might still work
    // (some long strings with many non-alphanumeric chars might still encode small)
    if (str.length <= 15) {
        const oldEncoded = oldEncode(str);
        if (!isNaN(oldEncoded) && oldEncoded > 0 && oldEncoded <= VARINT_SAFE_LIMIT) return oldEncoded;
    }
    // Only use hash-based encoding when necessary (long/complex IDs)
    let hash = fnv1a32(str);
    const baseHash = hash;
    // Handle collisions efficiently - use linear probing with a small limit
    let attempts = 0;
    const maxAttempts = 10;
    while(attempts < maxAttempts){
        const normalizedHash = hash % VARINT_SAFE_LIMIT;
        const existing = idReverseMap.get(normalizedHash);
        if (existing === undefined) {
            // Slot is free
            idReverseMap.set(normalizedHash, str);
            return normalizedHash;
        } else if (existing === str) // Already stored
        return normalizedHash;
        // Collision - linear probe with better distribution
        hash = baseHash + attempts * 2654435761; // Golden ratio multiplier for better distribution
        attempts++;
    }
    // If all slots are taken, use the hash anyway (rare case)
    return baseHash % VARINT_SAFE_LIMIT;
};
const decode = (number)=>{
    // Fast path: check reverse map first (for hashed IDs from current session)
    const cached = idReverseMap.get(number);
    if (cached !== undefined) return cached;
    // Try old decoding method (optimized)
    const numStr = String(number);
    const decoded = oldDecode(numStr);
    if (decoded !== null) // Quick verification: check if re-encoding matches (only for short strings)
    {
        if (decoded.length <= 20) {
            const reencoded = oldEncode(decoded);
            if (reencoded === number) return decoded;
        }
    }
    // Fallback: return number as string
    return String(number);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"awwGd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LIVE_DATA_MAX_AGE_MS", ()=>LIVE_DATA_MAX_AGE_MS);
/**
 * Return true if an arrival/trip has lastRefreshMs and it is older than LIVE_DATA_MAX_AGE_MS.
 * @param {Object} trip - Arrival/trip object (may have lastRefreshMs)
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isArrivalStale", ()=>isArrivalStale);
/**
 * Return a copy of a service with only non-stale arrivals (next/next2/next3 or arrivals array).
 * If an item has lastRefreshMs older than 15 minutes, it is excluded.
 * @param {Object} service - Service object with next, next2, next3 and/or arrivals
 * @returns {Object}
 */ parcelHelpers.export(exports, "filterStaleArrivalsFromService", ()=>filterStaleArrivalsFromService);
/**
 * Utility to fetch live bus arrival data from the arrivals API
 * @param {string} apiPath - The API path from city config
 * @param {string|number} stationId - The station/stop ID
 * @returns {Promise} Promise resolving to arrival data
 */ parcelHelpers.export(exports, "fetchArrivals", ()=>fetchArrivals);
/**
 * Extract service numbers from arrivals data
 * @param {Object} arrivalsData - The API response containing services
 * @returns {Array} Array of service numbers
 */ parcelHelpers.export(exports, "extractServiceNumbers", ()=>extractServiceNumbers);
/**
 * Get the next arrival for a specific service
 * @param {Object} arrivalsData - The API response containing services
 * @param {string} serviceNo - The service number to find
 * @returns {Object|null} The next arrival object or null if not found
 */ parcelHelpers.export(exports, "getNextArrivalForService", ()=>getNextArrivalForService);
/**
 * Group arrivals by service number with all their trips
 * @param {Object} arrivalsData - The API response containing services
 * @returns {Object} Object with service numbers as keys and their arrivals as values
 */ parcelHelpers.export(exports, "groupArrivalsByService", ()=>groupArrivalsByService);
/**
 * Convert duration_ms to a human-readable time string
 * @param {number} durationMs - Duration in milliseconds
 * @returns {string} Human-readable time string (e.g., "5 min", "1 min", "Arriving")
 */ parcelHelpers.export(exports, "formatArrivalTime", ()=>formatArrivalTime);
/**
 * Fetch upcoming routes/services at a stop (Phase 1 of two-phase fetch).
 * Returns arrival ETAs without waiting for vehicle positions.
 * @param {string} apiPath - The arrivals API path from city config
 * @param {string|number} stationId - The station/stop ID
 * @param {AbortSignal} [signal] - Optional AbortSignal for cancellation
 * @returns {Promise<{services: Array, servicesArrivals: Object, source: string}|null>}
 *   An object (with possibly-empty `services`) on a successful response, or
 *   `null` when the fetch fails — letting callers tell "no buses" from an error.
 *   `source` is what the endpoint derived its ETAs from ('api' or 'gtfs-rt').
 */ parcelHelpers.export(exports, "fetchStopRoutes", ()=>fetchStopRoutes);
/**
 * Fetch vehicle positions for all routes at a stop (Phase 2 of two-phase fetch).
 * Uses the batched stop-vehicles endpoint to get positions in a single request.
 * @param {string} vehiclesApiPath - The stop-vehicles API path from city config
 * @param {Array<string>} serviceNumbers - Service numbers to fetch vehicles for
 * @param {AbortSignal} [signal] - Optional AbortSignal for cancellation
 * @returns {Promise<Array<{no: string, lat: number, lng: number}>>}
 */ parcelHelpers.export(exports, "fetchStopVehicles", ()=>fetchStopVehicles);
/**
 * Check if arrival data is fresh (less than 5 minutes old based on first arrival)
 * @param {Object} arrivalsData - The API response containing services
 * @returns {boolean} True if data appears fresh
 */ parcelHelpers.export(exports, "isArrivalDataFresh", ()=>isArrivalDataFresh);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _cityConfigJs = require("../city-config.js");
const LIVE_DATA_MAX_AGE_MS = 900000;
function isArrivalStale(trip) {
    if (!trip || trip.lastRefreshMs == null) return false;
    return Date.now() - Number(trip.lastRefreshMs) > LIVE_DATA_MAX_AGE_MS;
}
function filterStaleArrivalsFromService(service) {
    if (!service) return service;
    const list = service.arrivals ? [
        ...service.arrivals
    ] : [
        service.next,
        service.next2,
        service.next3,
        service.next4,
        service.next5
    ].filter(Boolean);
    const fresh = list.filter((trip)=>!isArrivalStale(trip));
    const result = (0, _objectSpread._)({}, service);
    var _fresh_;
    result.next = (_fresh_ = fresh[0]) !== null && _fresh_ !== void 0 ? _fresh_ : null;
    var _fresh_1;
    result.next2 = (_fresh_1 = fresh[1]) !== null && _fresh_1 !== void 0 ? _fresh_1 : null;
    var _fresh_2;
    result.next3 = (_fresh_2 = fresh[2]) !== null && _fresh_2 !== void 0 ? _fresh_2 : null;
    var _fresh_3;
    result.next4 = (_fresh_3 = fresh[3]) !== null && _fresh_3 !== void 0 ? _fresh_3 : null;
    var _fresh_4;
    result.next5 = (_fresh_4 = fresh[4]) !== null && _fresh_4 !== void 0 ? _fresh_4 : null;
    if (service.arrivals) result.arrivals = fresh;
    return result;
}
async function fetchArrivals(apiPath, stationId) {
    if (!apiPath || !stationId || (0, _cityConfigJs.isApiDisabled)()) return null;
    try {
        const url = `${(0, _cityConfigJs.getApiUrl)(apiPath)}?stationid=${stationId}`;
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Failed to fetch arrivals: ${response.status}`);
        const data = await response.json();
        return data;
    } catch (error) {
        return null;
    }
}
function extractServiceNumbers(arrivalsData) {
    if (!arrivalsData || !arrivalsData.services || arrivalsData.services.length === 0) return [];
    return arrivalsData.services.map((service)=>service.no).filter(Boolean);
}
function getNextArrivalForService(arrivalsData, serviceNo) {
    if (!arrivalsData || !arrivalsData.services) return null;
    const service = arrivalsData.services.find((s)=>s.no === serviceNo);
    return (service === null || service === void 0 ? void 0 : service.next) || null;
}
function groupArrivalsByService(arrivalsData) {
    if (!arrivalsData || !arrivalsData.services) return {};
    const grouped = {};
    arrivalsData.services.forEach((service)=>{
        if (!grouped[service.no]) grouped[service.no] = {
            destination: service.destination,
            frequency: service.frequency,
            arrivals: []
        };
        // Add all available arrivals (next through next5)
        if (service.next) grouped[service.no].arrivals.push(service.next);
        if (service.next2) grouped[service.no].arrivals.push(service.next2);
        if (service.next3) grouped[service.no].arrivals.push(service.next3);
        if (service.next4) grouped[service.no].arrivals.push(service.next4);
        if (service.next5) grouped[service.no].arrivals.push(service.next5);
    });
    return grouped;
}
function formatArrivalTime(durationMs) {
    if (!durationMs || durationMs < 0) return 'N/A';
    const minutes = Math.floor(durationMs / 60000);
    if (minutes === 0) return 'Arriving';
    else if (minutes === 1) return '1 min';
    else return `${minutes} min`;
}
async function fetchStopRoutes(apiPath, stationId, signal) {
    if (!apiPath || !stationId || (0, _cityConfigJs.isApiDisabled)()) return null;
    try {
        var _data_services;
        const url = `${(0, _cityConfigJs.getApiUrl)(apiPath)}?stationid=${stationId}`;
        const response = await fetch(url, signal ? {
            signal
        } : undefined);
        if (!response.ok) throw new Error(`Failed to fetch arrivals: ${response.status}`);
        const data = await response.json();
        const source = (data === null || data === void 0 ? void 0 : data.source) || 'api';
        // Valid response with no services is "online but empty", not an error —
        // callers distinguish this (empty result) from a fetch failure (null).
        if (!(data === null || data === void 0 ? void 0 : (_data_services = data.services) === null || _data_services === void 0 ? void 0 : _data_services.length)) return {
            services: [],
            servicesArrivals: {},
            source
        };
        const services = data.services.map(filterStaleArrivalsFromService).filter((s)=>s.next || s.arrivals && s.arrivals.length > 0);
        const servicesArrivals = {};
        services.forEach((service)=>{
            if (service.next && (!servicesArrivals[service.no] || servicesArrivals[service.no] > service.next.duration_ms)) servicesArrivals[service.no] = service.next.duration_ms;
        });
        return {
            services,
            servicesArrivals,
            source
        };
    } catch (error) {
        if (error.name === 'AbortError') throw error;
        return null;
    }
}
async function fetchStopVehicles(vehiclesApiPath, serviceNumbers, signal) {
    if (!vehiclesApiPath || !(serviceNumbers === null || serviceNumbers === void 0 ? void 0 : serviceNumbers.length) || (0, _cityConfigJs.isApiDisabled)()) return [];
    try {
        var _data_vehicles;
        const routes = serviceNumbers.map(encodeURIComponent).join(',');
        const url = `${(0, _cityConfigJs.getApiUrl)(vehiclesApiPath)}?routes=${routes}`;
        const response = await fetch(url, signal ? {
            signal
        } : undefined);
        if (!response.ok) return [];
        const data = await response.json();
        if (!(data === null || data === void 0 ? void 0 : (_data_vehicles = data.vehicles) === null || _data_vehicles === void 0 ? void 0 : _data_vehicles.length)) return [];
        return data.vehicles.filter((v)=>typeof v.lat === 'number' && typeof v.lng === 'number' && !(v.lat === 0 && v.lng === 0)).flatMap((v)=>(v.routeNames || []).map((no)=>({
                    no,
                    lat: v.lat,
                    lng: v.lng
                })));
    } catch (error) {
        if (error.name === 'AbortError') throw error;
        return [];
    }
}
function isArrivalDataFresh(arrivalsData) {
    if (!arrivalsData || !arrivalsData.services || arrivalsData.services.length === 0) return false;
    // Check if at least one service has a next arrival
    return arrivalsData.services.some((service)=>service.next && service.next.duration_ms >= 0);
}

},{"@swc/helpers/_/_object_spread":"2eaR5","../city-config.js":"7oMBO","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"aqsOV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"4b2KT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LiveDataIndicator);
var _preact = require("preact");
var _cityConfigJs = require("../city-config.js");
const SOURCE_TITLES = {
    'gtfs-rt': 'Live data from the GTFS-RT.',
    api: 'Live data from the API.'
};
const DEFAULT_ERROR_TITLE = 'Live data unavailable. Estimated based on timetable schedule.';
const toggleTooltip = (e)=>{
    e.stopPropagation();
    const container = e.currentTarget;
    container.classList.toggle('show-tooltip');
    const closeTooltip = (event)=>{
        if (!container.contains(event.target)) {
            container.classList.remove('show-tooltip');
            document.removeEventListener('click', closeTooltip);
        }
    };
    setTimeout(()=>{
        document.addEventListener('click', closeTooltip);
    }, 0);
};
function LiveDataIndicator({ loading, error, source, errorTitle = DEFAULT_ERROR_TITLE }) {
    const sourceTitle = !loading && !error && source ? SOURCE_TITLES[source] : null;
    if (!error && (!(0, _cityConfigJs.isDevMode)() || !loading && !sourceTitle)) return null;
    return (0, _preact.h)("span", {
        class: `live-data-loading-container ${error ? 'error' : ''}`,
        title: error ? errorTitle : loading ? 'Fetching live information' : sourceTitle,
        onClick: toggleTooltip
    }, error ? (0, _preact.h)("span", {
        class: "live-data-warning"
    }, "\u26A0") : loading ? (0, _preact.h)("span", {
        class: "live-data-loading"
    }) : (0, _preact.h)("span", {
        class: `live-data-source live-data-source-${source}`
    }));
}

},{"preact":"ej31g","../city-config.js":"7oMBO","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"ioORP":[function(require,module,exports,__globalThis) {
/**
 * Stop/route metrics
 *
 * Usage:
 *   import { stopMetrics, routeMetrics } from './utils/metricsPage';
 *
 *   stopMetrics('blr', '22387', 'arrival');
 *   routeMetrics('blr', '500C', 'main');
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stopMetrics", ()=>stopMetrics);
parcelHelpers.export(exports, "routeMetrics", ()=>routeMetrics);
var _cityConfigJs = require("../city-config.js");
const ENDPOINT = '/api/usage/metrics';
// Debounce to avoid duplicate entries on rapid navigation
const recentEntries = new Map();
const DEBOUNCE_MS = 2000;
/**
 * Metric for a stop or route
 * @param {string} type - Metric type: 'stop_view' or 'route_view'
 * @param {string} city - City code (e.g., 'blr')
 * @param {string} id - Stop ID or route ID
 * @param {string} page - Page source: 'arrival' or 'main'
 */ const metrics = async (type, city, id, page)=>{
    if (!city || !id) return;
    if ((0, _cityConfigJs.isApiDisabled)()) return;
    // Debounce duplicate entries
    const key = `${type}:${city}:${id}:${page}`;
    const now = Date.now();
    const lastRecorded = recentEntries.get(key);
    if (lastRecorded && now - lastRecorded < DEBOUNCE_MS) return;
    recentEntries.set(key, now);
    // Clean up old entries periodically
    if (recentEntries.size > 100) {
        for (const [k, v] of recentEntries)if (now - v > DEBOUNCE_MS * 2) recentEntries.delete(k);
    }
    try {
        // Use sendBeacon for reliable delivery even on page unload
        // Fall back to fetch if sendBeacon is not available
        const payload = JSON.stringify({
            type,
            city,
            id,
            page
        });
        if (navigator.sendBeacon) {
            // Wrap in Blob with JSON content type - sendBeacon with plain string sends as text/plain
            const blob = new Blob([
                payload
            ], {
                type: 'application/json'
            });
            navigator.sendBeacon(ENDPOINT, blob);
        } else fetch(ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: payload,
            keepalive: true
        }).catch(()=>{
        // Silently fail - should not break the app
        });
    } catch (e) {
    // Silently fail - should not break the app
    }
};
const stopMetrics = (city, stopId, page)=>{
    metrics('stop_view', city, stopId, page);
};
const routeMetrics = (city, routeId, page)=>{
    metrics('route_view', city, routeId, page);
};

},{"../city-config.js":"7oMBO","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"fwRP1":[function(require,module,exports,__globalThis) {
/**
 * Pure schedule-derived ETA helpers shared by the stop panel
 * (components/BusServicesArrival.js) and the /arrival page (arrival.js).
 *
 * Keeping this math in one place guarantees both pages compute identical
 * scheduled ETAs. Schedule trip times are "HH:MM[:SS]" strings in local time;
 * hours may exceed 24 for after-midnight trips. Times are treated at
 * whole-minute granularity and never wrapped to the next day — once the last
 * trip of the day has passed, a route simply has no upcoming scheduled ETA.
 */ /**
 * Minutes-of-day for a "HH:MM[:SS]" schedule time.
 * @param {string} time
 * @returns {number|null} Minutes since midnight, or null if unparseable.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseScheduleMinutes", ()=>parseScheduleMinutes);
/**
 * Upcoming departures later today from a list of schedule trip times.
 * @param {string[]} trips
 * @param {Date} [now]
 * @returns {Array<{minutes: number, duration_ms: number}>} Soonest first.
 */ parcelHelpers.export(exports, "upcomingDepartures", ()=>upcomingDepartures);
/**
 * Milliseconds until the next scheduled departure later today.
 * @param {string[]} trips
 * @param {Date} [now]
 * @returns {number|null} ms until the soonest upcoming trip, or null if none remain.
 */ parcelHelpers.export(exports, "nextDepartureMs", ()=>nextDepartureMs);
/**
 * Next scheduled departure (ms) per route, from a stop's schedule JSON.
 * When a route has multiple direction entries, the soonest is kept.
 * @param {{services?: Array<{no: string, origin: string, trips: string[]}>}} scheduleData
 * @param {{originStopId?: string|number|null, now?: Date}} [options]
 *   originStopId — when set, only routes that originate at this stop are included.
 * @returns {Map<string, number>} route number → ms until next departure.
 */ parcelHelpers.export(exports, "scheduleETAByRoute", ()=>scheduleETAByRoute);
function parseScheduleMinutes(time) {
    const match = typeof time === 'string' && /^(\d{1,2}):(\d{2})/.exec(time);
    return match ? Number(match[1]) * 60 + Number(match[2]) : null;
}
function upcomingDepartures(trips, now = new Date()) {
    if (!Array.isArray(trips)) return [];
    const nowMinutes = now.getHours() * 60 + now.getMinutes();
    const result = [];
    for (const trip of trips){
        const minutes = parseScheduleMinutes(trip);
        if (minutes == null) continue;
        const duration_ms = (minutes - nowMinutes) * 60000;
        if (duration_ms > 0) result.push({
            minutes,
            duration_ms
        });
    }
    return result.sort((a, b)=>a.duration_ms - b.duration_ms);
}
function nextDepartureMs(trips, now = new Date()) {
    if (!Array.isArray(trips) || !trips.length) return null;
    const nowMinutes = now.getHours() * 60 + now.getMinutes();
    let best = Infinity;
    for (const trip of trips){
        const tripMinutes = parseScheduleMinutes(trip);
        if (tripMinutes == null) continue;
        const diff = tripMinutes - nowMinutes;
        if (diff > 0 && diff < best) best = diff;
    }
    return best === Infinity ? null : best * 60000;
}
function scheduleETAByRoute(scheduleData, { originStopId = null, now = new Date() } = {}) {
    var _scheduleData_services;
    const map = new Map();
    scheduleData === null || scheduleData === void 0 ? void 0 : (_scheduleData_services = scheduleData.services) === null || _scheduleData_services === void 0 ? void 0 : _scheduleData_services.forEach((s)=>{
        if (originStopId != null && String(s.origin) !== String(originStopId)) return;
        const ms = nextDepartureMs(s.trips, now);
        if (ms == null) return;
        const existing = map.get(s.no);
        if (existing == null || ms < existing) map.set(s.no, ms);
    });
    return map;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"7XWv2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ArrivalTimeText);
var _preact = require("preact");
function ArrivalTimeText({ ms }) {
    if (ms === null) return;
    const totalMinutes = Math.floor(ms / 1000 / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (hours > 0 && minutes > 0) return `${hours}h${minutes}m`;
    else if (hours > 0) return `${hours}h`;
    else return `${minutes}m`;
}

},{"preact":"ej31g","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}]},[], null, "parcelRequire5b81", {})

//# sourceMappingURL=transitrouter.473ccced.js.map
